import Cover from "../../components/Cover/Cover";
import "./AboutProductionPage.css";
import coverImage from "../../assets/images/mainCoverImage.webp";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";
import aboutProductionAboutFirstImage from "../../assets/images/aboutProductionAboutFirstImage.webp";
import aboutProductionAboutSecondImage from "../../assets/images/aboutProductionAboutSecondImage.webp";
import aboutProductionAboutThirdImage from "../../assets/images/aboutProductionAboutThirdImage.webp";
import aboutProductionAboutFourthImage from "../../assets/images/aboutProductionAboutFourthImage.webp";
import aboutProductionAboutFifghtImage from "../../assets/images/aboutProductionAboutFifghtImage.webp";
import abouteCertificate1 from "../../assets/images/aboutCertificates/ISO 14001 новий.webp";
import abouteCertificate2 from "../../assets/images/aboutCertificates/ISO 27001 новий.webp";
import abouteCertificate3 from "../../assets/images/aboutCertificates/ISO 37001 новий.webp";
import abouteCertificate4 from "../../assets/images/aboutCertificates/Сертифікат ISO 22000.webp";
import abouteCertificate5 from "../../assets/images/aboutCertificates/Сертифікат ISO 28000.webp";
import abouteCertificate6 from "../../assets/images/aboutCertificates/Сертифікат ISO 45001_Страница_1.webp";
import abouteCertificate7 from "../../assets/images/aboutCertificates/Сертифікат ISO 45001_Страница_2.webp";
import abouteCertificate8 from "../../assets/images/aboutCertificates/Сертифікат ISO 9001.webp";

const certificates = [
    abouteCertificate1,
    abouteCertificate2,
    abouteCertificate3,
    abouteCertificate4,
    abouteCertificate5,
    abouteCertificate6,
    abouteCertificate7,
    abouteCertificate8,
]

const AboutProductionPage = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  return (
    <div className="page">
         <title>ТОВ «Миколаївмолпром» — сучасне виробництво молочної продукції Pastoral</title>
       <meta name="description" content={"ТОВ «Миколаївмолпром» — виробник натуральної молочної продукції під ТМ «Pastoral» та «Мумуля». Високі стандарти якості, сучасне обладнання, європейські технології та міжнародні сертифікати ISO."}/>
      <Cover text={"“Pastoral” -  Французькі традиції"} src={coverImageToUse} />
      <section className="about__production-about">
        <div className="about__production-about-first">
          <div className="about__production-about-first-texts">
            <h1 className="about__production-about-first-title mont-m">
              ТОВ Миколаївмолпром
            </h1>
            <p className="about__production-about-first-text int-r-21">
              ТОВ «Миколаївмолпром» було засновано у 2001 році. На базі
              підприємства проведено реконструкцію та організовано випуск
              молочної продукції під торгівельною маркою «Pastoral».
            </p>
            <p className="about__production-about-first-text int-r-21">
              Продукція ТОВ "Миколаївмолпром" - це перш за все якість, за яку ми
              відповідаємо. Для організації виробництва високоякісної продукції
              на комплексі була проведена велика реконструкція.
            </p>
            <p className="about__production-about-first-text int-r-21">
              Ім`я бренду «Pastoral» натхненно французькою молочною культурою.
            </p>
            <p className="about__production-about-first-text int-r-21">
              З метою розширення дистрибуції у 2016 році ми створили Торговий
              дім «Доманівський маслосирзавод».
            </p>
            <p className="about__production-about-first-text int-r-21">
              У 2025 році запущена демократична та народна марка Мумуля, та
              розпочатий монтаж нового обладнання для запуску новинок.
            </p>
          </div>
          <img
            src={aboutProductionAboutFirstImage}
            alt="ТОВ Миколаївмолпром"
            className="about__production-about-first-image"
          />
        </div>
        <div className="about__production-about-second">
          <img
            src={aboutProductionAboutSecondImage}
            alt="Виробництво Миколаївмолпром"
            className="about__production-about-second-image"
          />
          <div className="about__production-about-second-cards">
            <div className="about__production-about-second-card">
              <h2 className="about__production-about-second-card-title mont-m">
                Натуральність
              </h2>
              <p className="about__production-about-second-card-text int-r-21">
                Ми використовуємо виключно натуральне молоко та інгредієнти.
                Наші продукти зберігають природний смак і користь молока.
              </p>
            </div>
            <div className="about__production-about-second-card">
              <h2 className="about__production-about-second-card-title mont-m">
                Інновації
              </h2>
              <p className="about__production-about-second-card-text int-r-21">
                Ми постійно вдосконалюємо рецептури, технологічні процеси,
                обладнання, орієнтуємось на сучасні харчові тренди.
              </p>
            </div>
            <div className="about__production-about-second-card">
              <h2 className="about__production-about-second-card-title mont-m">
                Користь
              </h2>
              <p className="about__production-about-second-card-text int-r-21">
                Ми створюємо молочну продукцію, щоб кожен, отримував
                збалансовані корисні речовини, підтримував здоров’я та був
                сповнений енергії.
              </p>
            </div>
            <div className="about__production-about-second-card">
              <h2 className="about__production-about-second-card-title mont-m">
                Відповідальність
              </h2>
              <p className="about__production-about-second-card-text int-r-21">
                Ми відповідально ставимося до безпеки продуктів та виробництва,
                але найбільшу відповідальність ми несемо за здоров’я споживачів.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="about__production-production-section">
        <h2 className="about__production-production-section-title mont-m">
          Виробництво
        </h2>
        <div className="about__production-production-wrapper">
            <div className="about__production-production-texts">
            <h3 className="about__production-production-subtitle mont-m">Поставка та перевірка молока:</h3>
        <p className="about__production-production-text int-r-21">
        Все молоко, з якого виробляється продукція Доманівського маслосирзаводу, закуповується у перевірених фермерських господарствах України та прибуває на завод у спеціальних машинах молоковозах. 
        </p>
        <p className="about__production-production-text int-r-21">
        Кожна партія молока проходить вхідний контроль у заводській лабораторії. Щоб гарантувати високу якість молочної продукції, ми встановили та дотримуємося внутрішніх вимог якості, які є суворішими, ніж рекомендовані державними нормативними документами.
        </p>
            </div>
            <img
                src={aboutProductionAboutThirdImage}
                alt="Виробництво Миколаївмолпром"
                className="about__production-production-image"
            />
        </div>
        <div className="about__production-production-wrapper reversed">
            <div className="about__production-production-texts">
            <h3 className="about__production-production-subtitle mont-m">Виготовлення продукції:</h3>
        <p className="about__production-production-text int-r-21">
        Уся цільномолочна продукція — від молока до масла — виготовляється з натурального молока. Кисломолочні продукти ми створюємо на основі європейських заквасок, а ряжанка набуває оксамитового смаку завдяки томлінню. 
        </p>
        <p className="about__production-production-text int-r-21">
        Сири готуємо традиційно: з дотриманням усіх етапів — соління, дозрівання, плавлення. Масло виробляємо зі 100% натуральних вершків методом збивання.
        </p>
            </div>
            <img
                src={aboutProductionAboutFourthImage}
                alt="Виробництво Миколаївмолпром"
                className="about__production-production-image two"
            />
        </div>
        <div className="about__production-production-wrapper">
            <div className="about__production-production-texts">
            <h3 className="about__production-production-subtitle mont-m">Аналіз готової продукції:</h3>
        <p className="about__production-production-text int-r-21">
        Контроль якості готової продукції  ТМ "Pastoral здійснюється відповідно до регламентів українського законодавства, державним вимогам та за міжнародними стандартами ISO 22000:2007. На кожну виробничу партію виписується сертифікат якості, підкріплений даними мікробіологічного контролю, контрольними органолептичними дегустаціями.
        </p>
            </div>
            <img
                src={aboutProductionAboutFifghtImage}
                alt="Виробництво Миколаївмолпром"
                className="about__production-production-image three"
            />
        </div>
      </section>
      <section className="about__production-certificates">
        <h2 className="about__production-certificates-title mont-m">
          Сертифікати
        </h2>
       <div className="about__production-certificates-wrapper">
        {certificates.map((cert, idx) => (
            <img
                key={idx}
                src={cert}
                alt={`Сертифікат ${idx + 1}`}
                className="about__production-certificates-image"
            />
        ))}
       </div>
      </section>
    </div>
  );
};

export default AboutProductionPage;
